<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="domesticAirFareCapObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">{{ title }}</p>
          <p>
            Trigger for any flight within the U.S. when the total cost is above
            <span class="rule-config-variable" @click="isEdit = !isEdit">{{
              domesticAirFareCapObj.value
                ? this.$options.filters.formatCurrency(domesticAirFareCapObj.value, 0, currencyCode)
                : "N/A"
            }}

              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>
        </div>
        <div class="allbtns">
          <b-switch :rounded="true" :value="domesticAirFareCapObj.isActive" v-model="domesticAirFareCapObj.isActive"
            @input="domesticAirfareCap" :left-label="true">{{ domesticAirFareCapObj.isActive ? 'Active' : 'Inactive' }}
          </b-switch>
        </div>
      </div>
    </div>

    <div v-if="isEdit" class="edittravelpolicy">
      <DomesticAirFareCap @domesticAirFareCap="getValue" :demesticAirFare="domesticAirFareCapObj.value" />
      <p>Enter amount</p>
      <b-button @click="saveCall">SAVE</b-button>
    </div>

    <StandardRuleActions v-if="domesticAirFareCapObj.isActive && !isEdit" :ruleObj="domesticAirFareCapObj"
      :title="title" @save="updateActions" />
  </div>
</template>
<script>
import DomesticAirFareCap from "../CommonRules/DomesticAirFareCap.vue";
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
  name: "",
  components: {
    DomesticAirFareCap,
    StandardRuleActions,
  },
  props: {
    value: {
      type: [Object],
    },
  },
  data() {
    return {
      domesticAirFareCapObj: this.value
        ? this.value
        : {
          name: "domesticAirfareCap",
          isActive: false,
          value: 500,
          type: "air",
          message: "",
        },
      isEdit: false,
      emitedValue: null,
      title: 'Domestic airfare cap'
    };
  },
  computed: {
    currencyCode() {
      return this.$store.getters['travellersAndTrips/getUserDefaultCurrency'];
    },
  },
  methods: {
    saveCall() {
      this.isEdit = false;
      if (this.emitedValue || this.emitedValue == "") {
        this.domesticAirFareCapObj.value = this.emitedValue;
      }
      this.buildMessage();
    },
    getValue(val) {
      this.emitedValue = val;
    },
    domesticAirfareCap() {
      if (!this.domesticAirFareCapObj.isActive) {
        // Clear the custom action parameters when deactivating
        this.clearActionParams();
      } else {
        // Rebuild message when activating
        this.buildMessage();
      }

      this.emitRuleObj();
    },
    clearActionParams() {
      // Reset to default actions when rule is not active ()
      this.domesticAirFareCapObj.useCustomActions = false;
      delete this.domesticAirFareCapObj.visibility;
      delete this.domesticAirFareCapObj.approvalLevel;
      delete this.domesticAirFareCapObj.notifications;
    },
    updateActions(updatedRule) {
      // Merge the updated properties into domesticAirFareCapObj
      this.domesticAirFareCapObj = { ...this.domesticAirFareCapObj, ...updatedRule };

      // If useCustomActions is false, delete the associated properties
      if (!updatedRule.useCustomActions) {
        this.clearActionParams();
      }

      this.buildMessage();

      this.emitRuleObj();
    },
    buildMessage() {
      var string = "Trigger for any flight within the U.S. when the total cost is above";
      var fullMessage = string + (this.domesticAirFareCapObj.value ? " " + this.$options.filters.formatCurrency(this.domesticAirFareCapObj.value, 0, this.currencyCode) : " N/A");

      this.domesticAirFareCapObj.message = fullMessage;
    },
    emitRuleObj() {
      this.$emit("domesticAirfareCap", this.domesticAirFareCapObj);
    }
  },
  mounted() {
    this.domesticAirFareCapObj.type = "air";

    this.emitRuleObj();
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.domesticAirFareCapObj = this.value;
        this.domesticAirFareCapObj.type = "air";
        this.buildMessage();
        this.emitRuleObj();

      },
      deep: true,
    },
  },
};
</script>
